export default class Menu {
  constructor(menuOpenSelector, menuCloseSelector, menuElement, menuOverlay) {
    this.menuOpen = document.querySelector(menuOpenSelector)
    this.menuClose = document.querySelector(menuCloseSelector)
    this.menuElement = document.querySelector(menuElement)
    this.menuOverlay = document.querySelector(menuOverlay)
    this.touchData = {
      startX: 0,
      endX: 0,
      startTime: 0,
      endTime: 0,
    }

    this.addMenuListeners()
    this.addSwipeListeners()
  }

  handleMenuOpen(e) {
    this.menuElement.classList.add('active')
    this.menuOverlay.classList.add('active')
    document.querySelector('body').style.overflowY = 'hidden'
  }

  handleMenuClose(e) {
    this.menuElement.classList.remove('active')
    this.menuOverlay.classList.remove('active')
    document.querySelector('body').style.overflowY = 'scroll'
  }

  addMenuListeners() {
    this.menuOpen.addEventListener('click', (e) => this.handleMenuOpen(e))
    this.menuClose.addEventListener('click', (e) => this.handleMenuClose(e))
    this.menuOverlay.addEventListener('click', (e) => this.handleMenuClose(e))
  }

  addSwipeListeners() {
    this.menuElement.addEventListener(
      'touchstart',
      (e) => this.handleSwipeStart(e),
      { passive: true }
    )
    this.menuElement.addEventListener('touchend', (e) => this.handleSwipeEnd(e))
  }

  handleSwipeStart(e) {
    this.touchData.startX = e.changedTouches[0].screenX
    this.touchData.startTime = e.timeStamp
  }

  handleSwipeEnd(e) {
    this.touchData.endX = e.changedTouches[0].screenX
    this.touchData.endTime = e.timeStamp

    const swipeLengthDiff = this.getSwipeLength()
    const swipeTimeDiff = this.getSwipeTime()

    if (swipeLengthDiff > 40 && swipeTimeDiff < 1500) {
      this.handleMenuClose()
    }
  }

  getSwipeLength() {
    return this.touchData.endX - this.touchData.startX
  }

  getSwipeTime() {
    return this.touchData.endTime - this.touchData.startTime
  }
}
